
<!--Top Menu Desktop-->
<ng-container *ngIf="this.toggleMenu == 2">
  <div class="top-menu" id="top-menu" [ngClass]="{'complete': this.completeMenu}">
    <div class="menu-container">
        <div class="search-bar-input" >
          <div class="div-input">
            <div class="icon-search"></div>
            <input class="desktop" [(ngModel)]="filter" (ngModelChange)="this.changeInput()" type="text" placeholder="Pesquise um produto" #inputDesktop>
            <div class="clear-searsh" *ngIf="this.filter.length > 0" (click)="clearFilter()">
              <i class="fa-solid fa-x cancel-input"></i>
            </div>
          </div>
        </div>
        <div class="menu-top-buttons" *ngIf="!this.readOnlyState && this.company" style="font-size: 20px;">
            <a class="btn" type="button" [routerLink]="['/', this.nameCompany, 'carrinho']" routerLinkActive="active"><i class="icon-shopping-cart" style="font-size: 20px;" aria-hidden="true"></i><span>Carrinho</span><span *ngIf="this.counterCart > 0" class="icon-quantity">{{ counterCart }}</span></a>
            <a [routerLink]="['/', this.nameCompany, 'consumption']" *ngIf="this.local" routerLinkActive="active"><i class="icon-book-open-text" style="text-align: center;"></i><span>Consumo</span></a>
            <a [routerLink]="['/', this.nameCompany, 'pedidos']" *ngIf="this.userConfirmation && !this.local" routerLinkActive="active"><i class="icon-book-open-text" style="text-align: center;"></i><span>Pedidos</span></a>
            <a [routerLink]="['/', this.nameCompany, 'user']" *ngIf="!this.local" routerLinkActive="active"><i class="icon-user" style="text-align: center;"></i><span>Perfil</span></a>
        </div>
    </div>
  </div>
</ng-container>

<!--Top mobile-->
<ng-container *ngIf="this.toggleMenu == 1 && this.company">
  <div class="background" [ngStyle]="{'background-image': this.backgroundLoad ? 'url(' + this.imgBackground + ')' : 'none'}" [ngClass]="{'loaded': this.backgroundLoad}"></div>
  <div class="box">
    <div class="box-info-company" [ngClass]="{'local': this.local, 'readOnly': this.readOnlyState}">
      <div class="img-logo" (click)="openInfoCompany = true">
        <img (load)="loadLogo()" [src]="this.img" [ngClass]="{'loaded': this.loadLogo}"/>
      </div>
      <div class="content-company">
        <span class="name-company">{{ this.company.company.companyName }}</span>

        <ng-container *ngIf="!this.readOnlyState">
          <span *ngIf="!this.local" class="open-company" [ngStyle]="{'color': this.statusCompany ? 'green' : '#d70000', 'background': this.statusCompany ? '#0080002b' : '#ff000040' }">{{ textStatusCompany }}</span>
          <span *ngIf="!this.local && this.company.configs.closeScheduling == 1" class="open-company" style="color: green; background-color: #0080002b; margin-top: 6px;">Disponível para agendamento</span>
        </ng-container>

        <!--Visivel se não estiver em modo Readonly-->
        <ng-container *ngIf="!this.readOnlyState">
          <!--Visivel se não for mesa ou comanda-->
          <div class="infos" *ngIf="!this.local">
            <!--Pedido Minimo-->
            <span *ngIf="this.company.configs.minValue != 0 && !this.localCounter">Min {{ this.company.configs.minValue | currency: 'BRL' }}</span>
            <div *ngIf="this.company.configs.minValue != 0 && this.company.companyHours.dataOpen && this.company.companyHours.dataClose && !this.localCounter"></div>

            <!--Status da loja-->
            <span *ngIf="!this.statusCompany && this.company.companyHours.dataOpen">Abre as {{ this.company.companyHours.dataOpen | timeFormat }}</span>
            <span *ngIf="this.statusCompany && this.company.companyHours.dataClose">Fecha as {{ this.company.companyHours.dataClose | timeFormat }}</span>

            <!--Tempo de preparo Delivery-->
            <ng-container *ngIf="!this.localCounter">
              <div *ngIf="this.timesInfo.delivery.active && this.statusCompany"></div>
              <span *ngIf="this.timesInfo.delivery.active">{{ this.timesInfo.delivery.label }}</span>
            </ng-container>

            <!--Tempo de preparo Balcão-->
            <ng-container *ngIf="this.localCounter">
              <div *ngIf="this.timesInfo.counter.active"></div>
              <span *ngIf="this.timesInfo.counter.active">{{ this.timesInfo.counter.label }}</span>
            </ng-container>

          </div>
        </ng-container>

      </div>
      <div class="box-input-mobile" [ngClass]="{'fixed': this.fixed && this.filter != '' || this.fixed && this.activeInput}">
        <i class="icon-search"></i>
        <input class="input-mobile" [(ngModel)]="filter" (ngModelChange)="this.changeInput()" type="text" #input placeholder="Pesquise um produto"/>
        <div class="clear-searsh-mobile" [ngClass]="{'fixed-clear': this.fixed}" style="right: 18px;" *ngIf="this.filter.length > 0" (click)="clearFilter()">
          <i class="fa-solid fa-x cancel-input"></i>
        </div>
        <button (click)="closeInput()" class="button-cancel" *ngIf="this.fixed">Cancelar</button>
      </div>
    </div>
    <div class="icons-info" style="left: 13px;" (click)="openInfoCompany = true">
      
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
    </div>
    <div class="icons-info" style="right: 15px;" (click)="share()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-share2-icon lucide-share-2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"/><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"/></svg>
    </div>
  </div>
</ng-container>

<app-info-company [openInfo]="this.openInfoCompany" (closeInfo)="this.openInfoCompany = false; this.scrollService.enableScroll()"></app-info-company>
